module.exports = __webpack_public_path__ + "assets/img/3.707b1173.gif";